import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BigTagContainer, NoneUserSelectText } from './big-tag.style'

interface IBigTagProps {
  ml?: string
  icon?: IconProp
  color: string
  text: string
  bgColor: string
}

const BigTag = ({ ml, icon, color, text, bgColor }: IBigTagProps) => {
  return (
    <BigTagContainer
      ml={ml}
      alignItems="center"
      px="sm"
      py="xs"
      bgColor={bgColor}
      borderColor={color}
    >
      {icon && <FontAwesomeIcon icon={icon} color={color} />}

      <NoneUserSelectText
        my="0"
        ml={icon ? 'xs' : '0'}
        color={color}
        fontWeight="semiBold"
      >
        {text}
      </NoneUserSelectText>
    </BigTagContainer>
  )
}

export default BigTag
